// ** Icons Import
import { useLocation } from 'react-router-dom'
const Footer = ({ }) => {
  const location = useLocation()
  function zIndexStyle() {
    if (location.pathname.split("/").includes("dashboard") === false) {
      return { zIndex: 1 }
    }
    return {}
  }
  return (
    <div className="copyrights_footerpanel" style={zIndexStyle()}>
      <div className="copyrights_footerpanel_left" style={{ paddingLeft: '0px' }}>© {new Date().getFullYear()} COPYRIGHT LISCR LLC, ALL RIGHTS RESERVED<span style={{ padding: "0px 12px" }}>|</span><span className="copyrights_footerpanel_middle"><a className="footer_email_link_privacy" href="https://www.liscr.com/contact-us/privacy-policy" target="_blank" style={{ color: "#838383" }}>Privacy Policy</a>
      </span></div>
      <div className="copyrights_footerpanel_right" style={{ paddingRight: '16px' }}>Contact us : <a className="footer_email_link" href="mailto:clientportalsupport@liscr.com">clientportalsupport@liscr.com</a></div>
    </div >
  )
}

export default Footer
